<template>
  <section id="test-vocacional">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 mx-auto d-flex justify-content-center align-items-center">
          <div class="content-wrapper my-5 bg-white rounded p-4 pb-5 w-100 position-relative">
            <div v-if="loading" class="icon-container text-center">
              <i class="loader"></i>
            </div>
            <!-- cabecera -->
            <div class="row">
              <div class="col-12">
                <div class="navigation d-inline-block">
                </div>
                <div class="progress mt-2">
                  <div class="progress-bar bg-ucam-gold" role="progressbar" :style="'width: ' +  progress + '%'" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
            <!-- ./end cabecera -->
            <!-- body -->
            <div class="row mt-5">
              <div class="col-md-7 order-2 mt-5 mt-md-0 order-md-1 d-md-flex" :class="showGraph?'col-12':'d-none'">
                <highcharts :options="chartOptions"></highcharts>
              </div>
              <div class="col-md-5 order-1 order-md-2">
                <transition name="slide-fade" mode="out-in">
                  <h3 :key="questionStore.selectedQuestion['pregunta']"  class="form-question mb-5" >{{questionStore.selectedQuestion['pregunta']}}</h3>
                </transition>
                  <button  :key="randomIndex(questionStore.index+5)" class="btn btn-outline-ucam-gray-medium btn-block" @click="preSaveQuestionAnswer({'answer': 5},$event)">Totalmente de acuerdo</button>
                  <button :key="randomIndex(questionStore.index+4)" class="btn btn-outline-ucam-gray-medium btn-block" @click="preSaveQuestionAnswer({'answer': 4},$event)">De acuerdo</button>
                  <button :key="randomIndex(questionStore.index+3)" class="btn btn-outline-ucam-gray-medium btn-block" @click="preSaveQuestionAnswer({'answer': 3},$event)">Indeciso</button>
                  <button :key="randomIndex(questionStore.index+2)" class="btn btn-outline-ucam-gray-medium btn-block" @click="preSaveQuestionAnswer({'answer': 2},$event)">En desacuerdo</button>
                  <button :key="randomIndex(questionStore.index+1)" class="btn btn-outline-ucam-gray-medium btn-block" @click="preSaveQuestionAnswer({'answer': 1},$event)">Totalmente en desacuerdo</button>
              </div>
            </div>
            <!-- ./end body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import {useQuestionStore} from "@/stores/question.js";
import {computed, onBeforeMount, ref, watch} from "vue";

const questionStore = useQuestionStore();
const showGraph = ref(false)

onBeforeMount(() => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const showGraphValue = urlParams.get('showGraph');
  if(showGraphValue === 'true'){
    showGraph.value = true;
  }
})

const loading = ref(false)

const chartOptions = ref({
  colors:['#edab00'],
  title: {
    text: 'Orientación profesional'
  },
  credits: {
    enabled: false
  },
  chart: {
    polar: true,
    type: 'line',
    style: {
      fontFamily: 'Open Sans,sans-serif'
    }
  },
  tooltip: {
    enabled: false
  },
  xAxis: {
    labels: {
      enabled: false
    },
    categories: ['', '', '', '',
      '', '','','',''],
    tickmarkPlacement: 'on',
    lineWidth: 0
  },

  yAxis: {
    labels: {
      enabled: false
    },
    gridLineInterpolation: 'polygon',
    lineWidth: 0,
    min: 0
  },
  plotOptions: {
    series: {
      events: {
        legendItemClick: function () {
            return false;
        }
      }
    },
    candlestick: {
      lineColor: '#edab00'
    },
  },
  series: [{
    name: 'Afinidad',
    data: [0,0,0,0,0,0,0,0,0]
  }],
})

const preSaveQuestionAnswer = (val,e) => {
  e.target.classList.remove('btn-outline-ucam-gray-medium');
  e.target.classList.add('btn-outline-primary');
  setTimeout(function () {
    e.target.classList.remove('btn-outline-primary');
    e.target.classList.add('btn-outline-ucam-gray-medium');
  }, 300);
  if (questionStore.index === (questionStore.questions.length - 1)) {
    loading.value = true;
    setTimeout(function () {
      questionStore.saveQuestionAnswer(val)
    }, 300);
  } else {
    questionStore.saveQuestionAnswer(val)
  }
}

const randomIndex = (max) => {
  setTimeout(function(){
    return Math.floor(Math.random() * 10000) + max;
  }, 300);
}

const progress = computed(()=>{
  return (questionStore.index * 100) / questionStore.questions.length
})

watch(() => questionStore.index, (val) => {
  questionStore.calc()
  chartOptions.value.series[0].data = questionStore.questionsResult;
  if(val === questionStore.questions.length){
    questionStore.step = 'crmform'
  }
})

</script>

<style>
  @media screen and (max-width:767px){
    .btn:hover{
      color: #9ca0a3!important;
      border-color: #9ca0a3!important;
      background-color: white!important;
    }
  }


  .btn:focus{
    box-shadow: none!important;
  }

  .highcharts-legend-item{
    display: none;
  }
  .slide-fade-enter-active {
    transition: all .2s ease;
  }
  .slide-fade-leave-active {
    transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for <2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }

  .loader {
    position: relative;
    height: 40px;
    width: 40px;
    display: inline-block;
    animation: around 5.4s infinite;
  }

  @keyframes around {
    0% {
      transform: rotate(0deg)
    }
    100% {
      transform: rotate(360deg)
    }
  }

  .loader::after, .loader::before {
    content: "";
    background: white;
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 100%;
    border-width: 2px;
    border-color: #333 #333 transparent transparent;
    border-style: solid;
    border-radius: 20px;
    box-sizing: border-box;
    top: 0;
    left: 0;
    animation: around 0.7s ease-in-out infinite;
  }

  .loader::after {
    animation: around 0.7s ease-in-out 0.1s infinite;
    background: transparent;
  }

</style>
